<div class="driver-side-list">
  <div class="content">

    <div class="ui-g-8 drivers">
      <div class="ui-g-12 add-driver p-0">
        <button id="driver-update-btn-add" type="button" (click)="onAddDriver()" [disabled]="isValidAddDriver()"
          class="btn btn-primary btn-add-driver">
          <i class="fas fa-plus"></i>
          Driver
        </button>
      </div>
      <div>
        <div *ngFor="let driver of drivers; let i = index">
          <div class="border-color driver-side-list-item">
            <app-driver-side-item-list [showForm]="driver.showForm" [customerId]="customer?._id" [driver]="driver"
              (toggleForm)="toggleForm(i)"></app-driver-side-item-list>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-4 other">
      <app-upcoming-appointment [isMarketingEnabled]="isMarketingEnabled" [isLoadingAppointment]="isLoadingAppointment"
        [appointments]="appointments" [vehicles]="vehicles" [exsistingEstimate]="estimate" [user]="customer"
        [tab]="'driver tab'">
      </app-upcoming-appointment>
    </div>

  </div>
</div>
